export default function getToken() {
  return localStorage.getItem("authToken");
}
